export default __webpack_public_path__ + "static/media/explanation-wrong.9cc274b0.png";